import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (fitExplanation: string) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: 'Career Path Fit Explanation',
    display:
      'Lubav-generated explanation of why this career path is a fit (or not) for the user based on their Blueprint survey answers.',
    data: {
      fitExplanation: fitExplanation || null,
    },
  });
};
